import { render, staticRenderFns } from "./VacancySectionCreateForm.vue?vue&type=template&id=037d1858&scoped=true"
import script from "./VacancySectionCreateForm.vue?vue&type=script&lang=ts"
export * from "./VacancySectionCreateForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037d1858",
  null
  
)

export default component.exports